import type { QueryClient } from '@tanstack/react-query';
import type { GeosetsGeosetsResponse } from '@customerio/hydra-ui-api';
import { geosetKeys, parseGeoset, type Geoset } from './entity';

/**
 * List response propagation for geosets.
 *
 * The endpoint returns `{ geosets }` (no pagination meta — the whole
 * collection arrives at once). Every row is also written into its detail
 * slot so a following by-id read can resolve from cache.
 */

export interface ParsedGeosetsListResponse {
  geosets: readonly Geoset[];
}

export function parseGeosetsListResponse(raw: GeosetsGeosetsResponse): ParsedGeosetsListResponse {
  return {
    geosets: raw.geosets.map(parseGeoset),
  };
}

export function populateGeosetsList(qc: QueryClient, workspaceId: number, response: ParsedGeosetsListResponse): void {
  for (const g of response.geosets) qc.setQueryData(geosetKeys.detail(workspaceId, g.id), g);
}
